export const DEFAULT_LOCALE = 'de-DE'
import get from 'lodash/get';
import type { Locale } from 'antd/es/locale';

import cs_CZ from 'antd/es/locale/cs_CZ';
import de_DE from 'antd/es/locale/de_DE';
import en_US from 'antd/es/locale/en_US';
import es_ES from 'antd/es/locale/es_ES';
import fr_FR from 'antd/es/locale/fr_FR';
import hr_HR from 'antd/es/locale/hr_HR';
import hu_HU from 'antd/es/locale/hu_HU';
import nl_NL from 'antd/es/locale/nl_NL';
import ro_RO from 'antd/es/locale/ro_RO';
import sk_SK from 'antd/es/locale/sk_SK';
import sl_SI from 'antd/es/locale/sl_SI';
import sr_RS from 'antd/es/locale/sr_RS';
import sv_SE from 'antd/es/locale/sv_SE';

import 'dayjs/locale/cs';
import 'dayjs/locale/de';
import 'dayjs/locale/en';
import 'dayjs/locale/es';
import 'dayjs/locale/fr';
import 'dayjs/locale/hr';
import 'dayjs/locale/hu';
import 'dayjs/locale/nl';
import 'dayjs/locale/ro';
import 'dayjs/locale/sk';
import 'dayjs/locale/sl';
import 'dayjs/locale/sr';
import 'dayjs/locale/sv';

export const getDefaultBrowserLanguage = () => {
  const language = get(navigator, 'language', get(navigator, 'userLanguage'));
  const lang = language.slice(0,2)
  return convertLanguageToUmiLocale(lang)
}

export const initializeLocale = () => {
  const localeInitialized = localStorage.getItem("localeInitialized")
  if (!localeInitialized){
    localStorage.setItem("umi_locale" , getDefaultBrowserLanguage())
    localStorage.setItem("localeInitialized" , "1")
  }
}
export const getLanguageFromUmiLocale = (language?:string): string => {
  const umiLocale = language ?? localStorage.getItem("umi_locale");
  return umiLocale ? umiLocale.split("-")[0] : "de";
};
const ANTD_LOCALE_MAP: Record<string, Locale> = {
  'cs-CZ': cs_CZ,
  'de-DE': de_DE,
  'en-US': en_US,
  'es-ES': es_ES,
  'fr-FR': fr_FR,
  'hr-HR': hr_HR,
  'hu-HU': hu_HU,
  'nl-NL': nl_NL,
  'ro-RO': ro_RO,
  'sk-SK': sk_SK,
  'sl-SI': sl_SI,
  'sr-RS': sr_RS,
  'sv-SE': sv_SE,
};

export const getAntdLocale = (umiLocale?: string): Locale => {
  const locale = umiLocale ?? localStorage.getItem('umi_locale') ?? DEFAULT_LOCALE;
  return ANTD_LOCALE_MAP[locale] ?? de_DE;
};

export const convertLanguageToUmiLocale = (language:string = ''): string => {
  if (typeof language !== "string") return DEFAULT_LOCALE

  const lang = language.slice(0,2)
  switch (lang) {
    case "cs":
      return "cs-CZ"
    case "de":
      return "de-DE"
    case "en":
      return "en-US"
    case "es":
      return "es-ES"
    case "fr":
      return "fr-FR"
    case "hr":
      return "hr-HR"
    case "hu":
      return "hu-HU"
    case "nl":
      return "nl-NL"
    case "ro":
      return "ro-RO"
    case "sk":
      return "sk-SK"
    case "sl":
      return "sl-SI"
    case "sr":
      return "sr-RS"
    case "sv":
      return "sv-SE"
    default:
      return DEFAULT_LOCALE
  }
};
